<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/organization']"> Organization </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/payment-info']"> Payment Information </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--6">
  <form [formGroup]="paymentInfoForm" (ngSubmit)="onSubmit()">
    <div formGroupName="payment">
      <!-- Main Bank -->
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-9 col-lg-9 col-sm-12">
              Bank Account Information
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Bank Name
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.bankName')?.invalid
                              && paymentInfoForm.get('payment.bankName')?.touched }" class="form-control"
                         formControlName="bankName"
                         id="bankNameInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.bankName')?.invalid     && paymentInfoForm.get('payment.bankName')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.bankName')?.hasError('required')">
                      Bank Name is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.bankName')?.hasError('maxlength')">
                      Bank Name cannot
                      exceed {{ paymentInfoForm.get('payment.bankName')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.bankName')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.bankName')?.errors?.['latinCharacters'].message }}
                    </div>

                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Bank Address
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.bankAddress')?.invalid
                              && paymentInfoForm.get('payment.bankAddress')?.touched }"
                         class="form-control"
                         formControlName="bankAddress"
                         id="bankAddressInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.bankAddress')?.invalid     && paymentInfoForm.get('payment.bankAddress')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.bankAddress')?.hasError('required')">
                      Bank Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.bankAddress')?.hasError('maxlength')">
                      Bank Address cannot
                      exceed {{ paymentInfoForm.get('payment.bankAddress')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.bankAddress')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.bankAddress')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Account Holder Name
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.accountHolderName')?.invalid
                             && paymentInfoForm.get('payment.accountHolderName')?.touched }" class="form-control"
                         formControlName="accountHolderName"
                         id="accountHolderNameInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.accountHolderName')?.invalid     && paymentInfoForm.get('payment.accountHolderName')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderName')?.hasError('required')">
                      Account Holder Name is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderName')?.hasError('maxlength')">
                      Account Holder Name cannot
                      exceed {{ paymentInfoForm.get('payment.accountHolderName')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderName')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.accountHolderName')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Account Holder Address
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.accountHolderAddress')?.invalid
                             && paymentInfoForm.get('payment.accountHolderAddress')?.touched }"
                         class="form-control"
                         formControlName="accountHolderAddress"
                         id="accountHolderAddressInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.accountHolderAddress')?.invalid     && paymentInfoForm.get('payment.accountHolderAddress')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderAddress')?.hasError('required')">
                      Account Holder Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderAddress')?.hasError('maxlength')">
                      Account Holder Address cannot
                      exceed {{ paymentInfoForm.get('payment.accountHolderAddress')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.accountHolderAddress')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.accountHolderAddress')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  IBAN
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.iban')?.invalid
                               && paymentInfoForm.get('payment.iban')?.touched && paymentInfoForm.get('payment.aba')?.invalid}" class="form-control"
                         formControlName="iban"
                         id="ibanInput" type="text" (change)="formIBANChange()">
                  <div
                    *ngIf="paymentInfoForm.get('payment.iban')?.invalid && paymentInfoForm.get('payment.iban')?.touched && paymentInfoForm.get('payment.aba')?.invalid"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.iban')?.hasError('required')">
                      IBAN Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.iban')?.hasError('maxlength')">
                      IBAN cannot
                      exceed {{ paymentInfoForm.get('payment.iban')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.iban')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.iban')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  BIC/SWIFT
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.swift')?.invalid
                               && paymentInfoForm.get('payment.swift')?.touched }" class="form-control"
                         formControlName="swift"
                         id="swiftInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.swift')?.invalid     && paymentInfoForm.get('payment.swift')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.swift')?.hasError('required')">
                      BIC/SWIFT is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.swift')?.hasError('maxlength')">
                      BIC/SWIFT cannot
                      exceed {{ paymentInfoForm.get('payment.swift')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.swift')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.swift')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  ABA
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.aba')?.invalid
                               && paymentInfoForm.get('payment.aba')?.touched && paymentInfoForm.get('payment.iban')?.invalid}" class="form-control"
                         formControlName="aba"
                         id="abaInput" type="text" (change)="formABAChange()">
                  <div
                    *ngIf="paymentInfoForm.get('payment.aba')?.invalid && paymentInfoForm.get('payment.aba')?.touched && paymentInfoForm.get('payment.iban')?.invalid"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.aba')?.hasError('required') && paymentInfoForm.get('payment.iban')?.invalid">
                      ABA Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.aba')?.hasError('maxlength') && paymentInfoForm.get('payment.iban')?.invalid">
                      ABA cannot
                      exceed {{ paymentInfoForm.get('payment.aba')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.aba')?.hasError('latinCharacters') && paymentInfoForm.get('payment.iban')?.invalid">
                      {{ paymentInfoForm.get('payment.aba')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Currency
                </label>
                <div class="col-md-9">
                  <select [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.currencyId')?.invalid
                               && paymentInfoForm.get('payment.currencyId')?.touched }"
                          class="form-control"
                          formControlName="currencyId" id="currencyDdl" name="cars">
                    <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                  </select>
                  <div
                    *ngIf="paymentInfoForm.get('payment.currencyId')?.invalid     && paymentInfoForm.get('payment.currencyId')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.currencyId')?.hasError('required')">
                      Currency is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.currencyId')?.hasError('maxlength')">
                      Currency cannot
                      exceed {{ paymentInfoForm.get('payment.currencyId')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.currencyId')?.hasError('pattern')">
                      Currency must use Latin characters only.
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

      <!-- Corresponding -->
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-9 col-lg-9 col-sm-12">
              Corresponding Bank
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Bank Name
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.correspondBankName')?.invalid
                              && paymentInfoForm.get('payment.correspondBankName')?.touched }" class="form-control"
                         formControlName="correspondBankName"
                         id="correspondBankNameInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.correspondBankName')?.invalid     && paymentInfoForm.get('payment.correspondBankName')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankName')?.hasError('required')">
                      Bank Name is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankName')?.hasError('maxlength')">
                      Bank Name cannot
                      exceed {{ paymentInfoForm.get('payment.correspondBankName')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankName')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.correspondBankName')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Bank Address
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.correspondBankAddress')?.invalid
                              && paymentInfoForm.get('payment.correspondBankAddress')?.touched }"
                         class="form-control"
                         formControlName="correspondBankAddress"
                         id="AHAddressInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.correspondBankAddress')?.invalid     && paymentInfoForm.get('payment.correspondBankAddress')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankAddress')?.hasError('required')">
                      Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankAddress')?.hasError('maxlength')">
                      Address cannot
                      exceed {{ paymentInfoForm.get('payment.correspondBankAddress')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondBankAddress')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.correspondBankAddress')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  IBAN
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.correspondIBAN')?.invalid
                               && paymentInfoForm.get('payment.correspondIBAN')?.touched }" class="form-control"
                         formControlName="correspondIBAN"
                         id="correspondIBANInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.correspondIBAN')?.invalid     && paymentInfoForm.get('payment.correspondIBAN')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.correspondIBAN')?.hasError('required')">
                      IBAN Address is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondIBAN')?.hasError('maxlength')">
                      IBAN cannot
                      exceed {{ paymentInfoForm.get('payment.correspondIBAN')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondIBAN')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.correspondIBAN')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  ABAN/BIC/SWIFT
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.correspondSWIFT')?.invalid
                               && paymentInfoForm.get('payment.correspondSWIFT')?.touched }" class="form-control"
                         formControlName="correspondSWIFT"
                         id="correspondSWIFTInput" type="text">
                  <div
                    *ngIf="paymentInfoForm.get('payment.correspondSWIFT')?.invalid     && paymentInfoForm.get('payment.correspondSWIFT')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.correspondSWIFT')?.hasError('required')">
                      ABAN/BIC/SWIFT is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondSWIFT')?.hasError('maxlength')">
                      ABAN/BIC/SWIFT cannot
                      exceed {{ paymentInfoForm.get('payment.correspondSWIFT')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondSWIFT')?.hasError('latinCharacters')">
                      {{ paymentInfoForm.get('payment.correspondSWIFT')?.errors?.['latinCharacters'].message }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Currency
                </label>
                <div class="col-md-9">
                  <select [ngClass]="{ 'is-invalid': paymentInfoForm.get('payment.correspondCurrencyId')?.invalid
                               && paymentInfoForm.get('payment.correspondCurrencyId')?.touched }"
                          class="form-control"
                          formControlName="correspondCurrencyId">
                    <option [ngValue]="null">Select Currency</option>
                    <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>
                  </select>
                  <div
                    *ngIf="paymentInfoForm.get('payment.correspondCurrencyId')?.invalid     && paymentInfoForm.get('payment.correspondCurrencyId')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="paymentInfoForm.get('payment.correspondCurrencyId')?.hasError('required')">
                      Currency is required.
                    </div>
                    <div *ngIf="paymentInfoForm.get('payment.correspondCurrencyId')?.hasError('maxlength')">
                      Currency cannot
                      exceed {{ paymentInfoForm.get('payment.correspondCurrencyId')?.errors?.['maxlength'].requiredLength }}
                      characters.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <button class="btn btn-primary" type="submit">Submit</button>
        <button [routerLink]="['/organization']" class="btn btn-secondary" type="button">Back</button>
      </div>
    </div>
  </form>



</div>
